/* globals $ */
import Component from './component';
import fromHtml from '../utils/from-html';
import flatpickr from '../vendors/flatpickr.min';
import { Polish } from '../vendors/flatpickr-local-pl';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {
  tooltipOffset: 100,
  maxVisibleElements: 3
};

export default class EventsCalendar extends Component {

  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;

    this.flatpickr = null;

    this.filter = { subcategory: '' };

    this.init();
  }

  init() {
    this.initDom();
    this.initFlatpickr();
    this.initTooltips();
  }

  initDom() {
    const {
      calendar,
      tooltips,
    } = fromHtml(this.$context[0]);

    this.$calendar = $(calendar);
    this.$tooltips = $(tooltips);
  }

  initFlatpickr() {
    this.flatpickr = flatpickr(this.$calendar[0], {
      inline: true,
      locale: Polish,
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        const date = EventsCalendar.dateToString(dayElem.dateObj);
        const $tooltip = this.getTooltip(date);

        dayElem.setAttribute('data-date', date);

        if ($tooltip.length) {
          dayElem.classList.add('busy');
          $tooltip[0].calendarDayElement = dayElem;
        }
      },
      onChange: dates => {
        const date = EventsCalendar.dateToString(dates[0]);

        // hide active tooltip
        this.hideTooltips();

        // show current tooltip
        this.showTooltip(date);
      },
    });
  }

  initTooltips() {
    // Close tooltip by click on X
    this.$context.on('click', '.icon-close', () => this.hideTooltips());

    // Close tooltip by click elsewhere
    $(document.body).on('click', ({ target }) => {
      if (!$(target).parents('.widget-tooltip').length) {
        this.hideTooltips();
      }
    });

    // set scroll position to tooltip container (for mobile purpose)
    this.$tooltips.on('scroll', (e) => {
      let $tt = $(e.currentTarget);

      $tt.attr('data-scroll', $tt.scrollTop())
    });
  }

  setFilter(filter) {
    this.filter = Object.assign({}, this.filter, filter);

    $.get(`?callendar=true&subcategory=${this.filter.subcategory}`, html => {
      let $newContext = $(html);

      this.$context.replaceWith($newContext);
      this.$context = $newContext;
      this.init();
    });
  }

  static dateToString(date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    month = (month + '').length === 1 ? '0' + month : month;
    day = (day + '').length === 1 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  }

  calcHeight($tt) {
    let length = $tt.find('article').length;
    let a, b = 0;

    if (length > this.settings.maxVisibleElements) {
      a = $tt.find('.date-bar').outerHeight();
      b = $tt.find('article').map((index, element) => {
        if (index < this.settings.maxVisibleElements) {
          return $(element).outerHeight();
        }
      }).get().reduce((a, b) => a + b);

      return a + b;
    }

    return 'auto';
  }

  getTooltip(dateString) {
    return this.$tooltips.filter(`[data-date="${dateString}"]`);
  }

  hasTooltip(dateString) {
    return !!this.getTooltip(dateString).length;
  }

  showTooltip(dateString) {
    if (this.hasTooltip(dateString)) {
      const $tooltip = this.getTooltip(dateString);
      const top = $($tooltip[0].calendarDayElement).position().top + this.settings.tooltipOffset;
      const height = this.calcHeight($tooltip);

      $tooltip.attr('data-scroll', '0').addClass(`active ${height !== 'auto' ? 'overflow': ''}`);
      $tooltip.css({
        top: `${top}px`,
        height: `${height}px`,
      });
    }
  }

  hideTooltips() {
    this.$tooltips.removeClass('active');
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('.js-event-calendar', EventsCalendar, 'EventsCalendar', $context, options);
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/events-calendar.js